import { postUsers } from '../api/postUsers';

export const setPostUsers = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await postUsers(params);
            alert('Сохранено');

            if (callback) {
                callback();
            }
        } catch (error) {
            alert(error?.response?.data?.message)
            console.log(error)
        }
    }
}